// Sprint 36 item 2: the game's panel for the player pages (roadmap, how it works, verify, rooms, the Lineup, practice).
// A link to one of them opens it in place (the address shows it, the history gets no extra step); a deep link (/roadmap) arrives with <body data-panel>. The page itself loads in the frame
// from /panel/<name>. "Back to the door" and Esc close it; the game behind it is inert while it is open.
import { PANELS, panelOf, frameSrc } from './panels.js';

const $ = id => document.getElementById(id);
const panel = $('panel'), frame = $('panel-frame');
let opener = null;
const behind = () => [...document.body.children].filter(e => e !== panel && e.id !== 'strip' && !/^(SCRIPT|SVG)$/i.test(e.tagName));

function show(name, search = '', hash = '') {
  $('panel-h').textContent = PANELS[name];
  frame.title = PANELS[name];
  const src = frameSrc(name, search, hash);
  if (frame.getAttribute('src') !== src) frame.setAttribute('src', src);
  panel.hidden = false;
  behind().forEach(e => { e.inert = true; });
  $('panel-back').focus();
}

function hide() {
  if (panel.hidden) return;
  panel.hidden = true;
  behind().forEach(e => { e.inert = false; });
  frame.removeAttribute('src');
  opener?.focus?.(); opener = null;
}

function close() {
  if (panel.hidden) return;
  hide();
  history.replaceState(null, '', '/');
}

document.addEventListener('click', e => {
  if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !panel.hidden) return;
  const a = e.target.closest?.('a[href]');
  if (!a || a.target) return;
  const u = new URL(a.href, location.href), name = u.origin === location.origin && panelOf(u.pathname);
  if (!name) return;
  e.preventDefault();
  const go = () => { opener = a; history.replaceState(null, '', u.pathname + u.search + u.hash); show(name, u.search, u.hash); };
  if (window.knockSession?.active()) return window.knockSession.ask(go); // a door in play: "Step away from the door?" first
  go();
});

$('panel-back').addEventListener('click', close);
document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); close(); } });
addEventListener('message', e => {
  if (e.origin !== location.origin || e.source !== frame.contentWindow) return;
  if (e.data?.t === 'panel-close') close();
  // a link from one panel page to another: the same panel shows it, the game behind it stays as it was
  if (e.data?.t === 'panel-open' && typeof e.data.url === 'string') {
    const u = new URL(e.data.url, location.href), name = u.origin === location.origin && panelOf(u.pathname);
    if (!name) return;
    history.replaceState(null, '', u.pathname + u.search + u.hash);
    show(name, u.search, u.hash);
  }
});
// the game itself opens a panel (the neighbour builder for the day's winner)
addEventListener('knock-panel', e => {
  const u = new URL(String(e.detail), location.href), name = panelOf(u.pathname);
  if (!name || !panel.hidden) return;
  history.replaceState(null, '', u.pathname + u.search + u.hash);
  show(name, u.search, u.hash);
});
addEventListener('popstate', () => {
  const name = panelOf(location.pathname);
  if (name) show(name, location.search, location.hash); else hide();
});

const first = document.body.dataset.panel;
if (first) show(first, location.search, location.hash);
